import React, { useState, useEffect } from "react";
import { Typography, Box, makeStyles, ButtonBase } from "@material-ui/core";
import { useRouter } from "next/router";
import dynamic from "next/dynamic";

const Lottie = dynamic(() => import("react-lottie"), { ssr: false });
import { useSpring, animated, config } from "react-spring";
import useAnimation from "./../../../animation";
import useUser from "hooks/useUser";
import SVGProfile from "../../../assets/profile.svg";
import AccountModal from "./components/AccountModal";
import LinkItem from "./components/LinkItem";
import HoverHeader from "./HoverHeader";
import MenuItem from "./components/MenuItem";
import MenuList from "./components/MenuList.js";
import LogoAnimation from "../../../assets/logo.json";
import SearchBar from "components/header/searchBar";
export const ACHETER = "ACHETER";
export const ENGAGEMENTS = "ENGAGEMENTS";
export const REPARER = "REPARER";
export const REPRISE = "REPRISE";
export const DONNER = "DONNER";
export const SERVICES = "SERVICES";
import ShopButtonDesktop from "components/cart/ShopButtonDesktop";
import BuildIcon from "@material-ui/icons/Build";
import ShoppingCartOutlinedIcon from "@material-ui/icons/ShoppingCartOutlined";
import SchoolIcon from "@material-ui/icons/School";
import useScroll from "hooks/useScroll";
import useDebounce from "hooks/useDebounce";

const ACCOUNT_PATH = "/reconditionne/se-connecter";

const MENU_LIST = [
  { text: "Réparer", href: "/", icon: <BuildIcon /> },
  { text: "Acheter", href: "/reconditionne/", icon: <ShoppingCartOutlinedIcon /> },
  { text: "Nous rejoindre", href: "/emploi/", icon: <SchoolIcon /> },
];

function formatName(user) {
  return `${(user.first_name || " ").slice(0, 1).toUpperCase()}${(user.first_name || "").slice(1)} ${(
    user.last_name || " "
  )
    .slice(0, 1)
    .toUpperCase()}.`;
}

export default function TopHeader({ resetSubHeader, productTypes, commercialCategories }) {
  const router = useRouter();
  const path = router.pathname;
  const smallLogo = router.pathname.includes("/mon-compte");
  const { asPath } = router;
  const classes = useStyle({ path, smallLogo });
  const [hovered, setHovered] = useState(null);

  const [user] = useUser();
  const [openAccountModal, setOpenAccountModal] = useState(false);
  const [animation, setAnimation] = useState(null);
  const show = useDebounce(useScroll(false), 100);

  const animate = useSpring({
    transform: `translateX(${animation ? "-150" : "0"}%) rotate(${animation ? -360 : 0}deg)`,
    opacity: animation ? "0" : "1",
    config: config.gentle,
  });

  useAnimation(animation, setAnimation);

  const LogoAnimationOptions = {
    loop: false,
    autoplay: true,
    animationData: LogoAnimation,
    rendererSettings: {
      preserveAspectRatio: "xMidYMid slice",
    },
  };

  function changeHovered(link) {
    resetSubHeader();
    setHovered(link);
  }

  useEffect(() => {
    setHovered(null);
    setOpenAccountModal(false);
  }, [router]);

  return (
    <>
      <div className={classes.topBar} onMouseLeave={() => changeHovered(null)}>
        <a href="/reconditionne" className={classes.homeIcon}>
          <animated.div style={animate}>
            <Lottie options={LogoAnimationOptions} height={92} width={100} className={classes.logo} />
          </animated.div>
        </a>
        <div className={classes.navContainer}>
          <Box className={classes.searchbar__container}>{show && <SearchBar />}</Box>
          <Box className={classes.menu_item__container}>
            {show && <MenuList text="Tous nos services" items={MENU_LIST} />}
            <MenuItem
              hovered={hovered === ENGAGEMENTS}
              text="Nos engagements"
              onMouseEnter={() => changeHovered(ENGAGEMENTS)}
              href="/nos-engagements"
              external
            />
          </Box>
        </div>
        <Box className={classes.profileContainer}>
          <ShopButtonDesktop color="white" />

          {!user.isAuthenticated ? (
            <div className={classes.accountLink}>
              <LinkItem
                href={`/reconditionne/se-connecter?referrer=${encodeURIComponent(asPath)}`}
                selected={path === ACCOUNT_PATH}
                rel="nofollow"
                account
              >
                <SVGProfile className={classes.profileIcon} />
              </LinkItem>
            </div>
          ) : (
            <div className={classes.accountLinkConnected}>
              <ButtonBase disableRipple onClick={() => setOpenAccountModal(true)}>
                <Typography className={classes.account}>{formatName(user.user)}</Typography>
                <SVGProfile className={classes.profileIcon} />
              </ButtonBase>
              {openAccountModal && <AccountModal onClose={() => setOpenAccountModal(false)} />}
            </div>
          )}
        </Box>
      </div>
      <HoverHeader hovered={hovered} productTypes={productTypes} commercialCategories={commercialCategories} />
    </>
  );
}

const useStyle = makeStyles((theme) => ({
  searchbar__container: {
    width: "50%",
  },
  menu_item__container: {
    display: "flex",
    alignItems: "center",
  },
  topHeader: {
    position: "relative",
    zIndex: 100,
  },
  accountLinkConnected: {
    color: "white",
    fill: "white",
    width: 100,
  },
  accountLink: {
    color: "white",
    fill: "white",
    "&:hover": {
      color: theme.palette.primary.main,
      fill: theme.palette.primary.main,
    },
  },
  profileIcon: {
    fill: "inherit",
    marginLeft: theme.spacing(2),
  },
  ticks: {
    position: "absolute",
    top: -3,
    right: -7,
  },
  topBar: {
    display: "flex",
    alignItems: "center",
    backgroundColor: theme.palette.secondary.main,
    paddingLeft: theme.spacing(5),
    paddingRight: theme.spacing(5),
    height: 80,
    justifyContent: "space-between",
  },
  account: {
    fontSize: 16,
    fontWeight: 500,
    color: "white",
  },
  navContainer: {
    display: "flex",
    alignItems: "center",
    maxHeight: 48,
    width: "100%",
  },
  homeIcon: {
    cursor: "pointer",
    width: 100,
  },
  logo: {
    fill: theme.palette.primary.main,
    position: "absolute",
  },
  profileContainer: {
    display: "flex",
    alignItems: "center",
    cursor: "pointer",
  },
}));
